import { FilterValue, Region } from "@/shared/types/type/search"

export const getRegionAllOption = (region: Region | undefined) => region?.children[0]

export const isRegionAllOptionId = (regionList: Region[], regionId: number) =>
  regionList.some((region) => getRegionAllOption(region)?.id === regionId)

export const isRegionAllSelected = (regionList: Region[], selectedRegions: FilterValue[]) => {
  if (selectedRegions.length !== 1) return false
  return isRegionAllOptionId(regionList, selectedRegions[0].id)
}

export const isRegionAllSelectionByIds = (regionList: Region[], regionIds: number[]) => {
  if (regionIds.length !== 1) return false
  const regionId = regionIds[0]
  if (regionList.some((region) => region.id === regionId)) return true
  return isRegionAllOptionId(regionList, regionId)
}
